import { render, staticRenderFns } from "./StatTotal.vue?vue&type=template&id=420e3bba&"
import script from "./StatTotal.vue?vue&type=script&lang=js&"
export * from "./StatTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports